export const LOGO_URL = "/logo.png?v=8";
export const LOGO_WHITE = "/logo-white.png?v=1";
export const PHONE_DISPLAY = "06 61 16 10 38";
export const PHONE_TEL = "+33661161038";
